import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Container, Row, Col, Button, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {hillStationData} from "../utils/constant";

const NatureShield = ()=>{
        const navigate = useNavigate();
     const [lightboxOpen, setLightboxOpen] = useState(false);
     const [lightboxImages, setLightboxImages] = useState([]);
     const [photoIndex, setPhotoIndex] = useState(0);
   
     const handleImageClick = (images, index) => {
       setLightboxImages(images);
       setPhotoIndex(index);
       setLightboxOpen(true);
     };
   
   // Reusable farm display component
   const FarmCard = ({ farm, onImageClick }) => (
     <Row className="d-flex justify-content-center align-items-center mb-5">
       <Col md={5} className="resort-card-modern">
         <Badge bg="light" text="dark" className="mb-3 px-3 py-2 fs-6">
           🏕 Resort Highlight
         </Badge>
         <h2 className="resort-title-modern mb-4">{farm.name}</h2>
   
         <table className="resort-table mb-4">
           <tbody>
             <tr><td> Price</td><td>{farm.price}</td></tr>
             <tr><td> Host</td><td><strong>{farm.host}</strong></td></tr>
             <tr><td> Address</td><td>{farm.address}</td></tr>
             <tr><td> City / District</td><td>{farm.city}</td></tr>
             <tr><td> State</td><td>{farm.state}</td></tr>
             <tr><td>Country</td><td>{farm.country}</td></tr>
           </tbody>
         </table>
   
         
 
   <Button
     variant="info"
     className="btn-more text-white px-4 py-2 fw-semibold"
     onClick={() => {
       const isLoggedIn = localStorage.getItem("user");
       const resortSlug = farm.name.toLowerCase().replace(/\s+/g, "-");
   
       if (isLoggedIn) {
         navigate(`/resort/${resortSlug}`);
       } else {
         const confirmRedirect = window.confirm("You must be logged in to continue. Do you want to login now?");
         if (confirmRedirect) {
           navigate("/login", { state: { redirectTo: `/resort/${resortSlug}` } });
         }
       }
     }}
   >
     {farm.discovermore}
   </Button>
   
   
       </Col>
   
       <Col md={7}>
         <Row className="justify-content-start">
           {farm.images.map((img, index) => (
             <Col key={index} md={6} lg={4} className="mb-4 d-flex justify-content-center">
               <div
                 className="position-relative image-hover-wrapper"
                 onClick={() => onImageClick(farm.images, index)}
                 style={{
                   cursor: "pointer",
                   width: "100%",
                   height: "200px",
                   borderRadius: "8px",
                   overflow: "hidden",
                   boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                 }}
               >
                 <img
                   src={img}
                   alt={`Farm ${index}`}
                   className="w-100 h-100"
                   style={{ objectFit: "cover" }}
                 />
                 <div className="hover-overlay" />
               </div>
             </Col>
           ))}
         </Row>
       </Col>
     </Row>
   );
   
   // Main Component
   
   
     return (
       <div style={{background:"#f0f0f0"}}>
       <Container className="py-5 text-center text-left p-4">
         {hillStationData.map((farm, index) => (
           <FarmCard key={index} farm={farm} onImageClick={handleImageClick} />
         ))}
   
         {lightboxOpen && (
           <Lightbox
             open={lightboxOpen}
             close={() => setLightboxOpen(false)}
             index={photoIndex}
             slides={lightboxImages.map((src) => ({ src }))}
           />
         )}
   
         {/* Hover effect styling */}
         <style>{`
           .image-hover-wrapper:hover .hover-overlay {
             opacity: 1;
           }
           .hover-overlay {
             position: absolute;
             top: 0; left: 0;
             width: 100%; height: 100%;
             background-color: rgba(13, 110, 253, 0.4);
             opacity: 0;
             transition: opacity 0.3s ease-in-out;
             z-index: 1;
           }
         `}</style>
       </Container>
       </div>
     );
   };
   
  
   
export default NatureShield;